import { Attributes } from '@leverege/ui-attributes';
import { useMemo } from 'react';
export default function useSeriesData(data, {
  xAccessor,
  objectType
}) {
  return useMemo(() => {
    const nameAttr = Attributes.getAttribute(`${objectType}.deviceId`, objectType);
    const obj = {};
    const seriesKeys = new Set();

    // Take all data and group by X coord value
    data.forEach(datum => {
      const name = nameAttr.get(datum?.data);
      if (!seriesKeys.has(name)) {
        seriesKeys.add(name);
      }
      const key = xAccessor(datum)?.toString();
      if (obj[key] != null) {
        obj[key] = [...obj[key], datum];
      } else {
        obj[key] = [datum];
      }
    });
    const seriesKeysArr = Array.from(seriesKeys);
    const nData = Object.entries(obj).map(([key, value]) => {
      return value.reduce((prev, curr) => {
        const name = nameAttr.get(curr?.data);
        if (!prev.x) {
          prev.x = xAccessor(curr);
        }
        if (name) {
          prev[name] = curr;
        }
        return prev;
      }, {});
    }).sort((itemA, itemB) => {
      let indexA = seriesKeysArr.indexOf(itemA.x);
      let indexB = seriesKeysArr.indexOf(itemB.x);
      indexA = indexA === -1 ? itemA.x : indexA;
      indexB = indexB === -1 ? itemB.x : indexB;
      if (indexA > indexB) {
        return 1;
      }
      return -1;
    });
    return {
      data: nData,
      seriesKeys: seriesKeysArr
    };
  }, [data, xAccessor]);
}